
<div class="answer-modal-container">
  <button type="button" (click)="close()" class="answer-modal-close" aria-label="Close">&times;</button>
  <button type="button" class="answer-modal-copy" (click)="copyAnswer()" aria-label="Copy to clipboard" title="Copy to clipboard">
    <span class="material-icons" style="font-size: 20px">content_copy</span>
  </button>
  <div style="margin-top: 20px;">
    <markdown #answerMarkdown [data]="toMarkdownString(data.answer)" class="ai-answer-markdown full" style="margin-top: 10px;"></markdown>
  </div>
</div>
